export default __webpack_public_path__ + "static/media/log-out-red.46844e13.svg";